<template>
  <main>
    <body>
      <div class="left">
        <div class="img-block">
          <div class="main-img-box">
            <img v-if="mainImg" class="main-img" :src="mainImg" />
            <img v-else class="main-img" :src="errImg" />
          </div>
          <div class="carousel">
            <el-carousel
              type="card"
              height="70px"
              arrow="always"
              :autoplay="false"
              @change="getIndex"
            >
              <el-carousel-item v-for="(img, index) in imgs" :key="index">
                <div class="select-img-box">
                  <img :src="img" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="box">
          <div class="span">
            {{ $t("product.prodDoc") }}
          </div>
          <div
            v-for="(item, index) in docs"
            :key="index"
            class="row"
          >
            <div>{{item['doc_local_type']}}</div>
            <a
              :href="tyDownloadURL + item['doc_local_url']"
              class="value link"
              target="_blank"
              >{{ item["doc_file_name"] }}</a
            >
          </div>
          <div class="row">
            <div>适配工具文档</div>
            <a
                :href="ossUrl + '%E5%B7%A5%E5%85%B7%E9%80%89%E5%9E%8B%E6%98%8E%E7%BB%86.pdf'"
                class="value link"
                target="_blank"
            >工具选型明细</a>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="box">
          <div class="head card">
            <div class="card-content">
              <div class="partNo">
                {{ prodData["产品型号"] }}
              </div>
              <div v-show="prodData.sampleFlag">
                <div class="tag">
                  <div class="el-icon-box" />
                  <div class="text">
                    {{ $t("product.sampAvl") }}
                  </div>
                </div>
                <div class="cart-func">
                  <el-input-number
                    v-model="num"
                    size="small"
                    :min="1"
                    :max="20"
                    class="counter"
                    @change="handleChange"
                  />
                  <el-button
                    icon="el-icon-shopping-cart-1"
                    size="small"
                    @click="addToCart"
                  >
                    {{ $t("product.addToCart") }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="span">
            {{ $t("product.productIntroduction") }}
          </div>
          <div
            v-for="(key, index) in overviewKeys"
            :key="'1-' + index"
            class="row"
          >
            <span class="key"
              >{{ $translate(cat, key) }}:&nbsp;&nbsp;&nbsp;</span
            >
            <span class="value">{{ $translate(cat, prodData[key]) }}</span>
          </div>

          <div class="span">
            {{ $t("product.detailedParams") }}
          </div>
          <div
            v-for="(key, index) in detailsKeys"
            :key="'2-' + index"
            class="row"
          >
            <span class="key"
              >{{ $translate(cat, key) }}:&nbsp;&nbsp;&nbsp;</span
            >
            <span class="value">{{ $translate(cat, prodData[key]) }}</span>
          </div>
        </div>
      </div>
    </body>
  </main>
</template>

<script>
import commonHeader from "@/components/CommonHeader";
import CommonFooter from "@/components/CommonFooter";
import baseUrl from "@/store/baseUrl";
import eventBus from "@/utils/eventBus";
import imgUtil from "@/utils/imgUtil";
import {downLoad} from "@/utils/http";
export default {
  name: "ProductDetail",
  components: {},
  data() {
    return {
      baseURL: baseUrl.state.downloadURL,
      tyDownloadURL: baseUrl.state.tyDownloadURL,
      ossUrl: baseUrl.state.ossUrl,
      errImg: require("@/assets/images/jdError.png"),
      id: this.$route.query.id,
      prodData: {},
      cat: "",
      overviewKeys: ["产品描述", "产品类别"],
      detailsKeys: [],
      otherKeys: [
          "原厂替换", "产品型号", "imgs", "docs", "sampleFlag",
          "替代料号1", "原厂型号", "替代品牌1", "替代料号", "替代品牌",
          "替代型号", "goods_imgs", "ty_documents", "ty_imgs", "ty_selling"
      ],
      imgs: [],
      docs: [],
      mainImg: null,
      loginVisible: false,
      isLogin: false,
      userId: null,
      num: 0,
    };
  },
  created() {
    this.initData();
    this.initCartInfo();
  },
  methods: {
    downLoad,
    initData() {
      let url = "/item/goodsQuery/loadDetailsByQuery";
      let params = { id: this.id };
      this.$doPost(url, params).then((res) => {
        if (res.code === 200) {
          this.prodData = res.data;
          this.cat = res.data["产品类别"];
          // 初始化详细参数
          for (let key in this.prodData) {
            if (
              this.overviewKeys.indexOf(key) === -1 &&
              this.otherKeys.indexOf(key) === -1 &&
              !key.startsWith("可替代")
            ) {
              this.detailsKeys.push(key);
            }
          }
          // 初始化图片列表
          this.imgs = imgUtil.getImgUrls(this.prodData);
          // this.imgs = imgs.splice(1, imgs.length);
          // this.imgs.push(imgs[0]);
          this.mainImg = this.imgs && this.imgs[0];
          this.docs = this.prodData["ty_documents"];
        }
      });
    },
    addToCart() {
      if (this.isLogin) {
        let url = "/cart/sample-cart/addSamplesToCart";
        let sampleCarts = [
          { partNo: this.prodData["产品型号"], amount: this.num },
        ];
        let param = {
          userId: this.userId,
          sampleCarts: sampleCarts,
        };
        this.$doPost(url, param, true).then((res) => {
          if (res.code === 200) {
            this.$message.success(
              this.$t("sampleApply.sampleApply.toCartSuccess")
            );
            eventBus.$emit("userId", this.userId);
          } else if (res.code === 2000) {
            this.$message.warning(
              this.$t("sampleApply.sampleApply.cartIsFull")
            );
          } else {
            this.$message.error(
              this.$t("sampleApply.sampleApply.toCartFailed")
            );
          }
        });
        return;
      }
      eventBus.$emit("isLogin", false);
      console.log("未登录");
    },
    handleChange() {},
    initCartInfo() {
      this.initUserId();
      if (this.isLogin) {
        this.initSampNum();
      }
    },
    initUserId() {
      this.userId = localStorage.getItem("userId");
      if (this.userId !== null) {
        this.isLogin = true;
      }
    },
    initSampNum() {
      let url = "/cart/sample-cart/getSampleCarts?userId=" + this.userId;
      let partNos = [this.prodData["产品型号"]];
      this.$doPost(url, partNos, true).then((res) => {
        if (res.code === 200) {
          let len = Object.keys(res.data).length;
          if (len > 0) {
            this.num = res.data[this.prodData["产品型号"]];
          }
        }
      });
    },
    getIndex(index) {
      this.mainImg = this.imgs[index];
    },
  },
};
</script>

<style scoped lang="less">
main {
  min-height: 100vh;
}
body {
  margin: 40px auto 120px auto;
  width: 80%;
  display: flex;
  font-family: "微软雅黑", "Arial Black";
  .left {
    width: 50%;
    .img-block {
      margin-top: 40px;
      .main-img-box {
        margin: 0 auto;
        width: 300px;
        height: 300px;
        .main-img {
          width: 300px;
          height: 300px;
          border: solid #d8d8d8 0.5px;
          border-radius: 5px;
        }
      }
      .carousel {
        margin: 20px auto;
        width: 400px;
        .el-carousel {
          width: 100%;
          /deep/ .select-img-box {
            margin: 0 auto;
            width: 50px;
            height: 100%;
            > img {
              width: 100%;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .right {
    width: 50%;
  }
}
.span {
  width: 400px;
  height: 40px;
  line-height: 40px;
  background: rgb(220, 220, 220);
  font-size: 18px;
  font-weight: bold;
  padding-left: 20px;
  margin: 20px 0 20px 0;
}
.row {
  line-height: 40px;
  .key {
    font-size: 16px;
    white-space: nowrap;
  }
  .value {
    font-size: 16px;
    color: rgb(80, 80, 80);
    white-space: break-spaces;
  }
}

.link {
  white-space: nowrap !important;
  &:hover {
    cursor: pointer;
    color: #FF8B3D;
  }
}
.box {
  width: 450px;
  margin: 0 auto;
  .head {
    margin-top: 50px;
    margin-bottom: 20px;
    .partNo {
      font-size: 25px;
      font-weight: bold;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .cart-func {
      display: flex;
      justify-content: space-between;
      .counter {
      }
      /deep/ .el-button {
        color: black;
        font-size: 15px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      }
    }

    .tag {
      display: flex;
      .el-icon-box {
        font-size: 25px;
        font-weight: 300;
        margin-right: 5px;
        line-height: 50px;
      }
      .text {
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
.card {
  line-height: 50px;
  background: white;
  width: 420px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 15px;
}
.card-content {
  padding: 20px;
}
</style>
